import { PlaceOrderModeSelection } from 'components/PlaceOrderModeSelection'
import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { updateSpotSelectedOrderMode } from 'store/spot/actions'
import { useSpotSelectedOrderMode } from 'store/spot/hooks'
import { OrderModeDetail, OrderModeDetails } from 'store/spot/types'
import { useSetAtom } from 'jotai'
import { orderPercentAtom } from '../AmountPercent/atoms'

export const OrderModeSelection = memo(() => {
  const dispatch = useDispatch()
  const currentMode = useSpotSelectedOrderMode()
  const setOrderPercent = useSetAtom(orderPercentAtom)

  const onHandleType = useCallback(
    (mode: OrderModeDetail) => {
      if (OrderModeDetails.find((item) => item.name === mode.name)) {
        dispatch(updateSpotSelectedOrderMode(mode.name))
        // Reset order percent slider
        setOrderPercent(0)
      }
    },
    [dispatch, setOrderPercent],
  )

  return (
    <PlaceOrderModeSelection
      modeDetails={OrderModeDetails}
      currentMode={currentMode}
      onHandleType={onHandleType}
    />
  )
})
